(function(root) {
define("cartware-slider", ["jquery","jquery-transit","jquery-throttle-debounce"], function() {
  return (function() {
!(function(factory) {
	if (typeof define === 'function' && define.amd) {
		require([
			'jquery'
		], factory);
	} else {
		factory(jQuery);
	}
})(function($) {
	if ($ === undefined) {
		throw new Error('jQuery is required to run this plug-in');
	}

	var animateAttributes = {
		left: 'left'
	};

	if ('transit' in $ && 'undefined' !== typeof Modernizr && Modernizr.csstransitions) {
		$.extend(animateAttributes, {
			left: 'x'
		});
	}

	function throttle (callback, limit, fireOnEnd) {
		fireOnEnd = ('undefined' === typeof fireOnEnd) ? true : !!fireOnEnd;

		var wait = false;

		return function () {
			if (!wait) {
				callback.call();
				wait = true;
				setTimeout(function () {
					wait = false;

					if (fireOnEnd) {
						callback.call();
					}
				}, limit);
			}
		};
	}

	function _t(string) {
		if ('undefined' !== typeof Translator && 'function' === typeof Translator.translate) {
			return Translator.translate(string);
		}

		return string;
	}

	var plugins = {

		autoResize: {
			construct: function() {
				this.settings.slidesToShow = 1;
				//
				// var _fitColsInWrap = this._fitColsInWrap;
				//
				// this._fitColsInWrap = function() {
				// 	var originalSlidesToShow = this.settings.slidesToShow;
				// 	this.settings.slidesToShow = 1;
				// 	var result = _fitColsInWrap.apply(this, arguments);
				// 	this.settings.slidesToShow = originalSlidesToShow;
				//
				// 	return result;
				// }
			},

			initialized: function() {
				// var slideshow = this;
				//
				// if ('slidesToShow' in slideshow.settings && slideshow.settings.slidesToShow > 1) {
				// 	if ('console' in window && 'function' === typeof console.warn) {
				// 		console.warn('Cartware slider: Using plugin \'autoResize\' although option \'slidesToShow\' is set. Skipping plugin.');
				// 	}
				//
				// 	return;
				// }
				//
				// /**
				//  * Set image width to current viewport width
				//  */
				// function stretchContent() {
				// 	var viewportWidth = slideshow.wrapper.width();
				//
				// 	slideshow.items.each(function() {
				// 		var slide = $(this);
				//
				// 		slide.width(viewportWidth);
				// 		$('img[data-resize]', slide).width(viewportWidth);
				// 	});
				//
				// 	slideshow.reflow();
				// }
				//
				// $(window).resize(('throttle' in $) ? $.throttle(150, stretchContent) : stretchContent);
				//
				// stretchContent();
			}
		},

		productMediaGallery: function(slideshow) {
			var productImage = $('#product-image');

			if (!productImage.length) {
				return;
			}

			slideshow.on('slide_click', function(e, slide) {
				var dataNode = $(slide).find('[data-detail-src]'),
					detailSrc = dataNode.data('detail-src'),
					img = new Image(),
					promise = $.Deferred();

				productImage.animate({
					opacity: 0
				}, {
					complete: function() {
						promise.resolve();
					}
				});

				img.onload = function() {
					promise.done(function() {
						productImage.attr('src', detailSrc);
						productImage.animate({
							opacity: 1
						});
					});
				};

				img.src = detailSrc;
			});
		},

		thumbnails: function(slideshow) {
			var itemTmpl = [
				'<li class="cartware-slider-item-wrap">',
				'<div class="cartware-slider-slide-item cartware-slider-slide-item-image row-1" data-slide-id="{slideId}">',
				'<div class="cartware-slider-slide-item-innerwrap">',

				'</div>',
				'</div>',
				'</li>'
			].join('');

			var items = [];

			$.each(slideshow.items, function(i) {
				var origItem = $(this),
					slideId = origItem.data('slide-id'),
					thumbnail = origItem.data('thumbnail') ?
						$('<img src="' + origItem.data('thumbnail') + '" alt="" />') :
						origItem.find('img:first').clone(),
					item = $(itemTmpl.replace('{slideId}', slideId));

				if (i === 0) {
					item.addClass('first');
				} else if (i === slideshow.items.length - 1) {
					item.addClass('last');
				}

				item.find('.cartware-slider-slide-item-innerwrap').append(thumbnail);
				items.push(item);
			});


			var thumbnailContainer = $([
					'<div class="cartware-slider thumbnails">',
					'<div class="cartware-slider-wrap">',
					'<div class="cartware-slider-stage">',
					'<ul class="cartware-slider-list cartware-slider-list-rows-1">',

					'</ul>',
					'</div>',
					'</div>',
					'</div>'
				].join('')),
				thumbnailSlider,
				list = thumbnailContainer.find('ul');

			$.each(items, function() {
				list.append(this);
			});

			thumbnailContainer.appendTo(slideshow.container);
			thumbnailContainer.cartwareSlider();
			thumbnailSlider = thumbnailContainer.data('cartware_slider/instance');

			slideshow.on('slide_after ready', function() {
				var activeItem = slideshow.activeItem,
					slideId = activeItem.find('[data-slide-id]').data('slide-id'),
					targetThumbnail = thumbnailContainer.find('[data-slide-id="' + slideId + '"]'),
					thumbApi = thumbnailContainer.data('cartware_slider');

				thumbApi.slideTo(targetThumbnail);
			});

			thumbnailSlider.on('slide_after', function() {
				thumbnailSlider.items.removeClass('active');
				thumbnailSlider.activeItem.addClass('active');
			});

			thumbnailSlider.items.on('click', function() {
				var item = $(this),
					slideId = item.data('slide-id'),
					targetSlide = slideshow.items.filter(function() {
						return $(this).data('slide-id') == slideId
					}),
					targetCol = targetSlide.parents('.cartware-slider-item-wrap:first');

				slideshow.slideTo(targetCol);
			});
		},

		swipe: function(slideshow) {
			var container = slideshow.container,
				wrapper = slideshow.wrapper,
				stage = slideshow.stage,
				$window = $(window),
				originalMode = slideshow.settings.mode,
				originalCarousel = slideshow.settings.carousel,
				isScroll = false,
				state = {
					isSwiping: false
				};

			var batches = slideshow.getBatches();

			slideshow.on('reflow', function() {
				batches = slideshow.getBatches();
			});

			container.data('cartware_slider/plugin/swipe/state', state);

			function setSwiping(flag) {
				state.isSwiping = flag;
			}

			function getCoordinates(event) {
				var originalEvent = event.originalEvent;

				if ('touches' in originalEvent) {
					event = originalEvent.touches[0];
				}

				return {
					x: event.pageX,
					y: event.pageY
				};
			}

			setSwiping(false);

			stage.on('click', function onClick(e) {
				if (state.isSwiping) {
					e.preventDefault();
					setSwiping(false);
				}
			});

			stage.on('dragstart', function(e) {
				if (batches.length < 2) {
					return;
				}

				e.preventDefault();
			});

			stage.on('touchstart mousedown', function(mouseDownEvent) {
				if (batches.length < 2) {
					return;
				}

				// Skip multi-touch gestures
				if ('touches' in mouseDownEvent.originalEvent && mouseDownEvent.originalEvent.touches.length > 1) {
					return;
				}

				var coordinates = getCoordinates(mouseDownEvent),
					originX = coordinates.x,
					originY = coordinates.y,
					deltaX = 0,
					deltaY = 0,
					originLeft = parseInt(stage.css(animateAttributes.left)),
					startTime = new Date().getTime();

				setSwiping(false);
				isScroll = false;

				function onMouseMove(mouseMoveEvent) {
					// Skip multi-touch gestures
					if ('touches' in mouseMoveEvent.originalEvent && mouseMoveEvent.originalEvent.touches.length > 1) {
						return;
					}

					var moveCoordinates = getCoordinates(mouseMoveEvent);

					deltaX = moveCoordinates.x - originX;
					deltaY = moveCoordinates.y - originY;

					if (!isScroll && !state.isSwiping && Math.abs(deltaX) > 10) {
						setSwiping(true);
					}

					if (!state.isSwiping && !isScroll && mouseMoveEvent.type === 'touchmove' && Math.abs(deltaY) > 20) {
						isScroll = true;
					}

					if (state.isSwiping && !isScroll) {
						stage.stop();
						stage.css(animateAttributes.left, originLeft + deltaX);
						mouseDownEvent.preventDefault();
						mouseMoveEvent.preventDefault();
					}
				}

				$window.on('touchmove mousemove', onMouseMove);

				$window.on('touchend mouseup', function onMouseUp() {
					$window.off('touchmove mousemove', onMouseMove);
					$window.off('touchend mouseup', onMouseUp);

					if (!state.isSwiping || isScroll) {
						return;
					}

					var currentTime = new Date().getTime(),
						deltaTime = currentTime - startTime,
						velocity = Math.abs(deltaX / deltaTime) || 0,
						isGesture = velocity <= 0.7;

					// slideshow.settings.mode = "columns";
					slideshow.settings.carousel = false;

					if (deltaX > 0) {
						slideshow.previous();
					} else if (deltaX < 0) {
						slideshow.next();
					}

					slideshow.settings.carousel = originalCarousel;
					// slideshow.settings.mode = originalMode;
				});
			});
		},

		columnOpacity: function(slideshow) {
			var container	= slideshow.container,
				wrapper		= slideshow.wrapper,
				stage		= slideshow.stage,
				cols		= slideshow.cols,
				items		= slideshow.items,
				minimumOpacity = 20;

			function fadeColumns() {
				var center = wrapper.width() / 2;

				cols.each(function() {
					var col = $(this),
						colItems = col.find('.cartware-slider-slide-item'),
						colCenter = col.position().left + col.width() / 2,
						opacity = Math.max(0, 1 - Math.abs(center - parseInt(stage.css('left'), 10) - colCenter) / center);

					colItems.animate({
						opacity: opacity + (minimumOpacity / 100 * (1 - opacity))
					});
				});
			}

			items.each(function() {
				var item = $(this),
					currentOpacity = null
					;

				item.hover(function() {
					currentOpacity = item.css('opacity');
					item.css({
						opacity: 1
					});
				}, function() {
					if (currentOpacity !== null) {
						item.css({
							opacity: currentOpacity
						});
					}
				});
			});

			slideshow.on('slide_after', fadeColumns);
			slideshow.on('slide_init', fadeColumns);
		},

		urlAnchor: function (slideshow) {
			if (!document.location.hash) {
				return;
			}

			//slideshow.on('ready', function() {
			var hash = document.location.hash.substr(1),
				marker = 'slide-',
				slideId = hash.substr(hash.indexOf(marker) + marker.length);

			slideshow.items.each(function() {
				var item = $(this), col;
				if (item.data('slide-id') == slideId) {
					col = item.parent();
					slideshow.slideTo(slideshow.cols.index(col), true);
					return false;
				}
			});
			//});
		}
	};

	var defaults = {
		settings: {
			autoslide: false,
			autoslide_interval: 5500,
			timeout: 1500,
			mode: 'columns', // options: columns, batches
			easing: ('easeOutBack' in $.easing) && ('ontouchstart' in document.documentElement) ? 'easeOutBack' : 'swing',
			speed: 650,
			carousel: false,
			shuffle: false,
			animateLayout: false,
			display: {
				nonFilledArrangement: 'center'
			},
			modesettings: {
				columns: {
					slidesPerMove: 1
				},

				batches: {}
			},
			controls: false,
			controlsettings: {
				handles: false,
				handleposition: 'bottom-center'
			},
			arrows: {
				position: 'middle'
			},
			thumbs: {
				display: false
			},
			plugins: ['swipe'],
			respondTo: 'window',
			labels: {
				controls: {
					previous: _t('Previous'),
					next: _t('Next')
				}
			}
		}
	};

	function ImagePool() {
		this._warm();
	}

	ImagePool.prototype = {
		_used: [],
		_free: [],
		_gcInterval: null,

		_warm: function() {
			var img;
			for (var i = 0; i < 10; i++) {
				img = new Image();
				img._recycleCount = 0;
				img.src = '';

				this._free.push(img);
			}

			if (!this._gcInterval) {
				this._initGc();
			}
		},

		_initGc: function() {
			var self = this,
				callback = function() {
					self._gc.call(self);
				};

			if (!this._gcInterval) {
				this._gcInterval = setInterval(callback, 3000);
			}
		},

		_pauseGc: function() {
			if (this._gcInterval) {
				clearTimeout(this._gcInterval);
				this._gcInterval = null;
			}
		},

		_gc: function() {
			for (var i = 0, l = this._free.length; i < l; i++) {
				this._resetObject(this._free[i]);
			}

			this._free = [];

			if (!this._used.length) {
				this._pauseGc();
			}
		},

		_resetObject: function(img) {
			img.onload = null;
			img.onerror = null;
			img.src = '';

			if ('TRANSPORT' in img) {
				img.TRANSPORT = null;
			}

			img._recycleCount++;

			return img;
		},

		alloc: function() {
			var img;

			if (!this._free.length) {
				this._warm();
			}

			img = this._free.pop();
			this._used.push(img);

			return img;
		},

		release: function(img) {
			var index = this._used.indexOf(this._resetObject(img));
			if (index >= 0) {
				this._free.push(this._used.splice(index, 1)[0]);
			}
		}
	};

	var GLOBAL_IMAGE_POOL = new ImagePool();

	function Slider(container, settings) {
		this._imagePool			= GLOBAL_IMAGE_POOL;
		this.container			= container;
		this.wrapper			= this.container.find('.cartware-slider-wrap');
		this.stage				= this.wrapper.find('.cartware-slider-stage');
		this.list				= this.stage.find('.cartware-slider-list');
		this.cols				= this.list.find('> .cartware-slider-item-wrap');
		this.items				= this.cols.find('.cartware-slider-slide-item');
		this.images				= this.items.find('img').not('.mobile-slide-image');
		this.thumbsContainer	= null;
		this.thumbsWrap			= null;
		this.activeItem			= this.cols.first();
		this.slideInterval		= null;
		this.slideIntervalMs    = parseInt(settings.autoslide_interval || this.slideIntervalMs);
		this.autoslidePaused    = false;
		this.settings			= $.extend({}, defaults.settings, settings);
		this.originalSettings	= $.extend({}, this.settings);
		this.body				= $('body');
		this.reflowTimeout		= null;
		this.initialized		= false;
		this.events				= {
			ready: []
		};
		this.currentBreakpoint	= null;
		this.defaultResponsive	= null;
		this.mobileFirst		= false;
		this.lastWrapperWidth	= null;
		this.lazyloadAttribute	= 'lazy';

		this.lazyloadPendingClass	= 'pending';
		this.lazyloadLoadedClass	= 'loaded';

		if (this.settings.plugins.indexOf('swipe') === -1) {
			this.settings.plugins.push('swipe');
		}

		this.settings.modesettings.columns.slidesPerMove = Math.max(1, parseInt(this.settings.modesettings.columns.slidesPerMove, 10));
		this.container.data('cartware_slider/settings', this.settings);


		// Export API
		var api = {
			slideTo:			$.proxy(this.slideTo, this),
			next:				$.proxy(this.next, this),
			previous:			$.proxy(this.previous, this),
			calibrate:			$.proxy(this.reflow, this),
			getVisibleItems:	$.proxy(this.getVisibleItems, this),
			on:					$.proxy(this.on, this),
			one:				$.proxy(this.one, this),
			off:				$.proxy(this.off, this),
			trigger:			$.proxy(this.trigger, this)
		};

		this.container.data('cartware_slider', api);

		this.callPluginMethod('construct');

		this._init();
	}

	Slider.prototype = {
		MODE_COLUMNS: 'columns',
		MODE_BATCHES: 'batches',
		MODE_CENTER: 'center',

		_init: function() {
			// Preload images
			var self = this,
				imagesToLoad = self.images.length,
				imagesLoaded = 0;

			if (0 === imagesToLoad) {
				return this.init();
			}

			this.container.addClass('loading');

			function iterate() {
				if (++imagesLoaded === imagesToLoad) {
					self.init();
				}
			}

			function onload() {
				self._imagePool.release(this);
				iterate();
			}

			function onerror() {
				$(this).remove();
				onload.call(this);
			}

			this.images.each(function() {
				var tmpImage,
					img = $(this);

				if (this.width > 1 && this.height > 1 && this.width !== this.height) {
					return iterate();
				}

				tmpImage = self._imagePool.alloc();
				tmpImage.onload = onload;
				tmpImage.onerror = onerror;
				tmpImage.src = img.data('original') || img.attr('src');
			});
		},

		init: function() {
			var self = this,
				preloadSlides = 1;

			if ('undefined' !== typeof this.settings.slidesToShow) {
				preloadSlides = this.settings.slidesToShow;
			}

			var lazyImages = this.items.slice(0, preloadSlides)
				.find('img')
				.filter(function() {
					return $(this).data(self.lazyloadAttribute);
				});

			var init = $.proxy(function() {
				this.initializeResponsive();
				this.initializeLayout();

				/*
				 stage.fadeOut(0);
				 stage.fadeIn();
				 */

				this.initializeEvents();

				if (this.settings.controls)	{
					this.initializeControls();
				}
				if (this.settings.controlsettings.handles) {
					this.initializeHandles();
				}
				if (this.settings.autoslide) {
					this.initializeInterval();
				}

				this.initializePlugins();

				this.container.trigger('cartware_slider/slide_init');
				this.container.removeClass('loading');

				this.initialized = true;
				this.trigger('ready');
			}, this);

			if (lazyImages.length) {
				this._lazyLoadImages(lazyImages, init);
			} else {
				init();
			}
		},

		on: function(eventString, cb) {
			var eventSplit = eventString.split(' '), i, j, event;

			for (i = 0, j = eventSplit.length; i < j; i++) {
				event = eventSplit[i];

				if (event === 'ready' && this.initialized) {
					cb.apply(this, [$.Event('ready')]);
					continue;
				}

				if (!(event in this.events)) {
					this.events[event] = [];
				}
				this.events[event].push(cb);
			}

			return this;
		},

		one: function(event, cb) {
			var self = this;

			this.on(event, function _onceCallback() {
				cb.apply(this, arguments);
				self.off(event, _onceCallback);
			});

			return this;
		},

		off: function(event, cb) {
			if ('undefined' === this.events[event]) {
				return;
			}

			if (cb) {
				this.events[event].splice(this.events[event].indexOf(cb), 1);
			} else {
				this.events[event] = [];
			}

			return this;
		},

		trigger: function(event, args) {
			var self = this;

			args = (args || []);
			args.unshift($.Event(event));

			if (!(event in this.events)) {
				return;
			}

			$.each(this.events[event], function() {
				this.apply(self, args);
			});

			return this;
		},

		_getNonFilledLeftValue: function(stageWidth) {
			var value = 0;

			switch (this.settings.display.nonFilledArrangement) {
				case 'center':
					value = (this.wrapper.outerWidth(true) - stageWidth) / 2;
					break;
				case 'right':
					value = (this.wrapper.outerWidth(true) - stageWidth);
					break;
			}

			return value;
		},

		_fitColsInWrap: function() {
			if ('undefined' === typeof this.settings.slidesToShow || !this.settings.slidesToShow) {
				return this;
			}

			var wrapperWidth = this.wrapper.width(),
				slidesToShow = this.settings.slidesToShow,
				targetWidth = parseInt(wrapperWidth / slidesToShow, 10);

			this.cols.each(function() {
				var item = $(this);

				item.css('width', targetWidth);
			});

			this.container.attr('class', this.container.attr('class').replace(/cartware-slider--slides-to-show-\d+/, '') + ' ' + 'cartware-slider--slides-to-show-' + slidesToShow);

			return this;
		},

		_renderControls: function() {
			if (this.settings.controls) {
				if (!this.container.find('.control-previous').length) {
					$('<div class="control control-previous">' + this.settings.labels.controls.previous + '</div>').appendTo(this.container);
				}

				if (!this.container.find('.control-next').length) {
					$('<div class="control control-next">' + this.settings.labels.controls.next + '</div>').appendTo(this.container);
				}
			}

			this.controls = {
				previous:	this.container.find('.control-previous'),
				next:		this.container.find('.control-next'),
				thumbs:		[]
			};
		},

		_lazyload: function (cb) {
			cb = cb || $.noop;

			var self = this;
			var images = this
				.getVisibleItems()
				.find('img')
				.filter(function() {
					return !!$(this).data(self.lazyloadAttribute);
				});

			this._lazyLoadImages(images, function() {
				// self.reflow();
				cb();
			});

			return this;
		},

		_lazyLoadImages: function(images, cb) {
			images = $(images);

			var self = this,
				imagesToLoad = images.length,
				imagesLoaded = 0;

			if (0 === imagesToLoad) {
				cb();
				return this;
			}

			function iterate() {
				if (++imagesLoaded === imagesToLoad) {
					cb();
				}
			}

			function onload() {
				var image = this.TRANSPORT;

				image.attr('src', this.src);

				setTimeout(function() {
					image.removeClass(self.lazyloadPendingClass)
						.addClass(self.lazyloadLoadedClass);
				}, 10);

				self._imagePool.release(this);
				iterate();
			}

			function onerror() {
				$(this).remove();
				onload.call(this);
			}

			images.each(function() {
				var tmpImage,
					img = $(this),
					src = img.data(self.lazyloadAttribute);

				tmpImage = self._imagePool.alloc();
				tmpImage.onload = onload;
				tmpImage.onerror = onerror;
				tmpImage.TRANSPORT = img;
				tmpImage.src = src;
			});
		},

		initializeLayout: function () {
			var self = this,
				stageWidth = 0,
				stageHeight = 0;
			//roundingInaccuracy = Math.round(this.body.width() / 2 - parseInt(this.body.width() / 2, 10));

			this._fitColsInWrap();
			this._renderControls();

			this.cols.each(function() {
				var item = $(this),
					rect = this.getBoundingClientRect ? this.getBoundingClientRect() : null,
					width = rect ?
						(rect.width || rect.right - rect.left) :
						item.outerWidth(false),
					height = rect ?
						(rect.height || rect.bottom - rect.top) :
						item.outerHeight(false);

				width += parseInt(item.css('margin-left'), 10) + parseInt(item.css('margin-right'), 10);
				height += parseInt(item.css('margin-top'), 10) + parseInt(item.css('margin-bottom'), 10);

				stageWidth += width;
				stageHeight = Math.max(stageHeight, height);
			});

			stageWidth = Math.ceil(stageWidth);
			stageHeight = Math.ceil(stageHeight);

			if (this.settings.shuffle) {
				this.shuffleColumns();
			}

			// TODO: Find out why elements wont float correctly without this
			// stageWidth += 1;

			if (this.settings.animateLayout) {
				this.stage.css('opacity', 0);
				this.stage.css('width', stageWidth);

				this.stage.animate({
					height: stageHeight,
					opacity: 1
				});
			} else {
				this.stage.css({
					width: stageWidth,
					height: stageHeight
				});
			}

			if (stageWidth < this.wrapper.width()) {
				this.stage.css(animateAttributes.left, this._getNonFilledLeftValue(stageWidth));
				if (this.settings.controls && !this.settings.carousel) {
					$.each(this.controls, function() {
						$(this).css('display', 'none');
					});
				}
			}

			if (self.settings.arrows.position === 'middle') {
				$.each([this.controls.previous, this.controls.next], function () {
					var control = $(this);

					control.css({
						visibility: 'hidden'
					});
				});
			}

			var wrapperHeight = stageHeight +
				parseInt(this.stage.css('padding-top'), 10) +
				parseInt(this.stage.css('padding-bottom'), 10) +
				parseInt(this.stage.css('margin-top'), 10) +
				parseInt(this.stage.css('margin-bottom'), 10);

			var onWrapperLayout = function() {
				if (self.settings.arrows.position === 'middle') {
					$.each([self.controls.previous, self.controls.next], function() {
						var control = $(this);

						control.css({
							top: self.wrapper.innerHeight() / 2 - control.innerHeight() / 2,
							visibility: 'visible'
						});
					});
				}
			};

			if (this.settings.animateLayout) {
				this.wrapper.animate({
					height: wrapperHeight
				}, {
					complete: onWrapperLayout
				});
			} else {
				this.wrapper.css({
					height: wrapperHeight
				});

				onWrapperLayout();
			}

			this.checkControls();
		},

		initializeEvents: function() {
			var container = this.container,
				self = this;

			container.hover(function() {
				container.trigger('cartware_slider/slide_mouseover');
				self.trigger('slide_mouseover');
			}, function() {
				container.trigger('cartware_slider/slide_mouseleave');
				self.trigger('slide_mouseleave');
			});

			this.items.hover(function() {
				$(this).addClass('hover');
			}, function() {
				$(this).removeClass('hover');
			});

			this.wrapper.on('click', '.cartware-slider-slide-item', function() {
				self.trigger('slide_click', [this]);
			});
		},

		initializeResponsive: function() {
			if (!$.isArray(this.settings.responsive)) {
				return;
			}

			var mobileFirst = this.settings.mobileFirst;
			var sortFlag = mobileFirst ? -1 : 1;

			this.settings.responsive.sort(function(a, b) {
				if (!a.breakpoint || !a.settings) {
					return -sortFlag;
				}

				if (!b.breakpoint || !b.settings) {
					return sortFlag;
				}

				return parseInt(a.breakpoint, 10) > parseInt(b.breakpoint, 10) ?
					sortFlag :
					(parseInt(a.breakpoint, 10) === parseInt(b.breakpoint, 10) ?
						0 :
						-sortFlag);
			});

			this.defaultResponsive = {
				breakpoint: this.settings.mobileFirst ? 0 : Infinity,
				settings: this.originalSettings
			};

			$(window).on('resize', throttle($.proxy(this._checkBreakpoint, this), 100));
			this._checkBreakpoint();
		},

		_checkBreakpoint: function() {
			var sliderWidth = this.wrapper.width();
			var windowWidth = window.innerWidth || $(window).width();
			var respondToWidth = windowWidth;

			if (this.settings.respondTo === 'slider') {
				respondToWidth = sliderWidth;
			} else if (this.settings.respondTo === 'min') {
				respondToWidth = Math.min(windowWidth, sliderWidth);
			}

			var mobileFirst = this.settings.mobileFirst;
			var targetEntry = null;
			var wrapperWidth = this.wrapper.width();

			$.each(this.settings.responsive, function(i, responsiveEntry) {
				var breakpoint = parseInt(responsiveEntry.breakpoint, 10) || null;
				var settings = responsiveEntry.settings || null;
				var innerTargetEntry = null;

				if (!breakpoint || !settings) {
					return;
				}

				if (mobileFirst) {
					if (respondToWidth > breakpoint) {
						innerTargetEntry = responsiveEntry;
					}
				} else {
					if (respondToWidth < breakpoint) {
						innerTargetEntry = responsiveEntry;
					}
				}

				if (!innerTargetEntry) {
					return;
				}

				if (!targetEntry) {
					targetEntry = innerTargetEntry;
				} else {
					if (mobileFirst) {
						if (parseInt(innerTargetEntry.breakpoint, 10) >= parseInt(targetEntry.breakpoint, 10)) {
							targetEntry = innerTargetEntry;
						}
					} else {
						if (parseInt(innerTargetEntry.breakpoint, 10) <= parseInt(targetEntry.breakpoint, 10)) {
							targetEntry = innerTargetEntry;
						}
					}
				}
			});

			if (!targetEntry)  {
				targetEntry = this.defaultResponsive;
			}

			var mustReflow = false;

			if (this.currentBreakpoint !== null && this.lastWrapperWidth !== wrapperWidth) {
				mustReflow = true;
			}

			if (targetEntry.breakpoint != this.currentBreakpoint) {
				this.settings = $.extend({}, this.originalSettings, targetEntry.settings);
				this.currentBreakpoint = targetEntry.breakpoint;
			}

			if (mustReflow) {
				this.reflowImmediately();
			}

			this.lastWrapperWidth = wrapperWidth;
		},

		initializeControls: function() {
			this.controls.next.bind('click', $.proxy(function() { this.next(); }, this));
			this.controls.next.hover(function() {
				$(this).addClass('hover');
			}, function() {
				$(this).removeClass('hover');
			});

			this.controls.previous.bind('click', $.proxy(function() { this.previous(); }, this));
			this.controls.previous.hover(function() {
				$(this).addClass('hover');
			}, function() {
				$(this).removeClass('hover');
			});

			this.container.bind('cartware_slider/slide_after', $.proxy(this.checkControls, this));
			this.container.addClass('cartware-slider--has-controls');
		},

		initializeHandles: function() {
			var handleposition = this.settings.controlsettings.handleposition;

			this.thumbsContainer = this.container.find('.thumbs-container');

			if (!this.thumbsContainer.length) {
				this.thumbsContainer = $('<div class="thumbs-container thumbs-container-' + handleposition + '">').appendTo(this.container);
			}

			if (!this.thumbsWrap) {
				this.thumbsWrap = $('<div class="thumbs-inner-wrap">').appendTo(this.thumbsContainer);
			}

			this.container.bind('cartware_slider/slide_after', $.proxy(this.determineActiveThumb, this));
			this.container.bind('cartware_slider/slide_init', $.proxy(this.determineActiveThumb, this));

			this.renderHandles();
			this.container.addClass('cartware-slider--has-handles');
		},

		renderHandles: function() {
			var thumbsList = $('<ul />');

			this.controls.thumbs = [];
			this.thumbsWrap.empty().append(thumbsList);

			if (this.settings.mode !== Slider.prototype.MODE_BATCHES) {
				// TODO: This seems obsolete, but the slideType=video logic is restricting refactor
				this.cols.each($.proxy(function(i) {
					var slide = $(this.cols[i]);
					var index = i;
					var slideType = 'default';
					if (slide.hasClass('cartware-slider-item-wrap--video')) {
						slideType = 'video';
					}
					var thumb = $('<a href="#" class="thumb thumb-' + slideType + ' thumb-' + index + '" />');

					thumb.html(i);
					thumbsList.append($('<li class="thumb-li-' + slideType + '" />').append(thumb));

					//thumb.appendTo(this.thumbsWrap);
					thumb.bind('click', $.proxy(function(e) {
						e.preventDefault();
						e.stopPropagation();

						this.slideTo(index);
					}, this));

					this.controls.thumbs.push(thumb);
				}, this));
			} else {
				var batches = this.getBatches();

				$.each(batches, $.proxy(function(i, batch) {
					var thumb = $('<a href="#" class="thumb thumb-default thumb-' + i + '" />'),
						item = batch[0];

					thumb.html(i);
					thumbsList.append($('<li class="thumb-li-default" />').append(thumb));

					//thumb.appendTo(this.thumbsWrap);
					thumb.bind('click', $.proxy(function(e) {
						e.preventDefault();
						e.stopPropagation();

						this.slideTo(item);
					}, this));

					this.controls.thumbs.push(thumb);
				}, this));

				if (batches.length < 2) {
					this.container.addClass('handles-disabled');
				} else {
					this.container.removeClass('handles-disabled');
				}
			}

			this.determineActiveThumb();
		},

		initializeInterval: function() {
			var self = this;

			this.container.bind('cartware_slider/slide_mouseover', function() {
				if (self.slideInterval) {
					clearInterval(self.slideInterval);
					self.slideInterval = null;
				}
			});

			this.container.bind('cartware_slider/slide_mouseleave', function() {
				if (!self.slideInterval && !self.autoslidePaused) {
					self.setupInterval();
				}
			});

			self.setupInterval();
		},

		setupInterval: function() {
			var self = this;
			self.slideInterval = setInterval(function() {
				self.next();
			}, self.slideIntervalMs);
		},

		initializePlugins: function() {
			var self = this;

			// Backwards compatibility
			$.each(this.settings.plugins, function() {
				var plugin = this;

				if (typeof plugin !== 'function' && !$.isPlainObject(plugin)) {
					if (!(plugin in plugins)) {
						return;
					}
					plugin = plugins[plugin];
				}

				if (typeof plugin === 'function') {
					plugin.call(self, self);
				}
			});

			this.callPluginMethod('initialized');
		},

		callPluginMethod: function(method) {
			var self = this,
				args = Array.prototype.slice.call(arguments, 1);

			$.each(this.settings.plugins, function() {
				var plugin = this;

				if (!$.isPlainObject(plugin)) {
					if (!(plugin in plugins)) {
						return;
					}
					plugin = plugins[plugin];
				}

				if (
					$.isPlainObject(plugin) &&
					'initialized' in plugin &&
					(typeof plugin[method] === 'function')
				) {
					plugin[method].apply(self, args);
				}
			});
		},

		getBatches: function() {
			var wrapperWidth = this.wrapper.width(),
				roundingInaccuracy = this.getRoundingInaccuracy(),
				rightConstraint = null,
				batches = [],
				self = this;

			this.cols.each(function() {
				var item = $(this),
					position = self.calculateItemPosition(item),
					batch = batches.length ? batches[batches.length - 1] : [];

				if (null === rightConstraint || position.left >= rightConstraint) {
					batch = [item];

					if (null === rightConstraint) {
						rightConstraint = wrapperWidth + roundingInaccuracy;
					} else {
						rightConstraint = position.left + wrapperWidth;
					}

					batches.push(batch);
					return;
				}

				batch.push(item);
			});

			return batches;
		},

		calculateItemPosition: function(item) {
			var position = item.position();
			position.right = position.left + item.width();
			position.bottom = position.top + item.height();
			return position;
		},

		pauseAutoslide: function(value) {
			var self = this;
			if (self.settings.autoslide === false) {
				return;
			}
			if (value === true) {
				self.autoslidePaused = true;
				if (self.slideInterval) {
					clearInterval(self.slideInterval);
					self.slideInterval = null;
				}
			} else {
				self.autoslidePaused = false;
				clearInterval(self.slideInterval);
				self.slideInterval = null;
				self.setupInterval();
			}
		},

		shuffleColumns: function() {
			if (this.cols.length < 2) {
				return;
			}

			var classes = this.cols.map(function() { return $(this).prop('class'); });

			this.cols.detach()
				.sort(function() { return 0.5 - Math.random(); })
				.each(function(i) {
					$(this).prop('class', classes[i]);
				})
				.appendTo(this.list);

			this.items				= this.cols.find('.cartware-slider-slide-item');
			this.images				= this.items.find('img').not('.mobile-slide-image');

			this.trigger('shuffle');
		},

		determineActiveThumb: function() {
			var index = 0;

			if (this.activeItem) {
				index = this.cols.index(this.activeItem);
			}

			if (this.settings.mode === Slider.prototype.MODE_BATCHES) {
				var batchNumber = 0;

				var batches = this.getBatches();

				$.each(batches, $.proxy(function(i, batch) {
					var firstBatchItem = $(batch[0]);

					if (firstBatchItem.position().left > -parseInt(this.stage.css(animateAttributes.left), 10)) {
						return false;
					}

					batchNumber = i;
				}, this));

				index = batchNumber;
			}

			$.each(this.controls.thumbs, function(i) {
				$(this)[(i === index) ? 'addClass' : 'removeClass']('active');
			});
		},

		checkControls: function() {
			var stageWidth = this.stage.width(),
				currentLeft = parseInt(this.stage.css(animateAttributes.left), 10),
				wrapperWidth = this.wrapper.width(),
				colCount = this.cols.length,
				allDisabled = true;

			$.each([this.controls.previous, this.controls.next], function(i) {
				var control = $(this);

				if (colCount === 1) {
					control.css('display', 'none');
					return;
				}

				if (stageWidth <= wrapperWidth) {
					control.addClass('disabled');
				} else {
					control.removeClass('disabled');

					if (currentLeft < 0) {
						if (i === 0) {
							control.removeClass('disabled');
						} else if (i === 1) {
							// TODO: remove 1px tolerance
							if (stageWidth + currentLeft - 1 <= wrapperWidth) {
								control.addClass('disabled');
							} else {
								control.removeClass('disabled');
							}
						}
					} else {
						if (i === 1) {
							control.removeClass('disabled');
						} else if (i === 0) {
							control.addClass('disabled');
						}
					}
				}
			});

			$.each([this.controls.previous, this.controls.next], function() {
				var control = $(this);
				allDisabled = allDisabled && control.hasClass('disabled');
				if (!allDisabled) {
					return false;
				}
			});

			if (allDisabled) {
				this.container.addClass('controls-disabled');
			} else {
				this.container.removeClass('controls-disabled');
			}
		},

		getRoundingInaccuracy: function() { // TODO
			return 0;
			// return Math.round(this.body.width() / 2 - parseInt(this.body.width() / 2, 10));
		},

		slideTo: function(index, noFx, mode) {
			var target = $.isNumeric(index) ? $(this.cols[index]) : index;
			this.next(target, noFx, mode);
		},

		next: function(nextItem, noFx, mode) {
			var totalLeft = this.wrapper.width() - parseInt(this.stage.css(animateAttributes.left), 10) ,
				lastFullVisible = this.cols.first(),
				lastCenterItem = null,
				targetLeft = 0,
				center = totalLeft - this.wrapper.width() / 2,
				roundingInaccuracy = this.getRoundingInaccuracy();

			noFx = noFx || false;
			mode = mode || this.settings.mode;

			nextItem = nextItem || null;

			if (nextItem === null) {
				this.cols.each(function() {
					var item = $(this);

					if (item.width() + item.position().left <= totalLeft + roundingInaccuracy) {
						lastFullVisible = item;
					}

					if (parseInt(item.position().left + item.width() / 2) <= center || lastCenterItem === null) {
						lastCenterItem = item;
					}
				});

				if (mode === Slider.prototype.MODE_BATCHES) {
					nextItem = lastFullVisible.next();

					if (!nextItem.length) {
						if (!this.settings.carousel) {
							nextItem = lastFullVisible;
						} else {
							nextItem = this.items.first().parent();
						}
					}
				} else {
					nextItem = lastCenterItem.next();

					$.proxy(function() { // Skip slides if set up multiple slides per move
						var i = this.settings.modesettings.columns.slidesPerMove;

						if (nextItem.length || !this.settings.carousel) {
							while(--i && (nextItem = nextItem.next())) { /* noop */ };
						} else {
							nextItem = this.items.first().parent();
						}

					}, this)();
				}
			}

//			if ((!nextItem || !nextItem.length) && !this.settings.carousel) {
//				return;
//			}

			if ((!nextItem || !nextItem.length)) {
				nextItem = this.cols.last();
			}

			if (nextItem.length) {
				switch (mode) {
					case Slider.prototype.MODE_BATCHES:
						targetLeft = - Math.min(nextItem.position().left, this.stage.outerWidth(true) - this.wrapper.outerWidth(true));
						break;

					case Slider.prototype.MODE_CENTER:
						targetLeft = - (nextItem.position().left + nextItem.outerWidth(true) / 2 - this.wrapper.width() / 2);
						break;

					case Slider.prototype.MODE_COLUMNS:
					default:
						targetLeft = - (nextItem.position().left + nextItem.outerWidth(true) / 2 - this.wrapper.width() / 2);
						//if (targetLeft < - (this.stage.width() - this.wrapper.width())) targetLeft = 0;

						// Exceed
						if (targetLeft < - (this.stage.width() - this.wrapper.width())) {
							// Limit to right side
							targetLeft = - (this.stage.width() - this.wrapper.width());

							if (this.settings.carousel) {
								// Return to beginning
								if (targetLeft === parseInt(this.stage.css(animateAttributes.left), 10)) {
									targetLeft = 0;
									nextItem = this.items.get(0);
								}
							}
						}

						break;
				}

				if (this.stage.width() < this.wrapper.width()) {
					targetLeft = this._getNonFilledLeftValue(this.stage.width());
				}
			}

			this.container.trigger('cartware_slider/slide_before');
			this.trigger('slide_before');


			var onComplete = $.proxy(function() {
				this._lazyload($.proxy(function() {
					this.activeItem = nextItem.length ? nextItem : null;
					this.container.trigger('cartware_slider/slide_after');
					this.trigger('slide_after');
				}, this));
			}, this);

			var targetStyles = {};
			targetStyles[animateAttributes.left] = targetLeft;

			if (noFx) {
				this.stage.css(targetStyles);

				onComplete();
			} else {
				this.stage.animate(targetStyles, {
					easing: this.settings.easing,
					duration: this.speed,
					complete: onComplete
				});
			}
		},

		previous: function(noFx) {
			var totalLeft = - parseInt(this.stage.css(animateAttributes.left), 10),
				previousItem,
				targetLeft = - (this.stage.width() - this.wrapper.width());

			if (this.settings.mode === Slider.prototype.MODE_BATCHES) {
				totalLeft -= this.wrapper.width();
				totalLeft = Math.max(1, totalLeft);
			}

			this.cols.each(function() {
				var item = $(this);
				if (item.position().left < totalLeft) {
					previousItem = item;
				}
			});

			if (parseInt(this.stage.css(animateAttributes.left), 10) === 0) {
				if (!this.settings.carousel) {
					return;
				}
				previousItem = this.cols.last();
			}

			if (this.settings.mode !== Slider.prototype.MODE_BATCHES) {
				$.proxy(function() { // Skip slides if set up multiple slides per move
					var i = this.settings.modesettings.columns.slidesPerMove;
					while(--i && (previousItem = previousItem.prev())) { /* noop */ };
				}, this)();

				if (!previousItem || !previousItem.length) {
					previousItem = this.cols.first();
				}
			}

			if (previousItem && previousItem.length) {
				targetLeft = - Math.min(previousItem.position().left, this.stage.width() - this.wrapper.width());
				if (this.stage.width() < this.wrapper.width()) {
					targetLeft = this._getNonFilledLeftValue(this.stage.width());
				}
			}

			this.container.trigger('cartware_slider/slide_before');
			this.trigger('slide_before');

			var onComplete = $.proxy(function() {
				this._lazyload($.proxy(function() {
					this.activeItem = previousItem.length ? previousItem : null;
					this.container.trigger('cartware_slider/slide_after');
					this.trigger('slide_after');
				}, this));
			}, this);

			var targetStyles = {};
			targetStyles[animateAttributes.left] = targetLeft;

			if (noFx) {
				this.stage.css(targetStyles);

				onComplete();
			} else {
				this.stage.animate(targetStyles, {
					easing: this.settings.easing,
					duration: this.speed,
					complete: onComplete
				});
			}
		},

		getVisibleItems: function() {
			var currentLeft = parseInt(this.stage.css(animateAttributes.left), 10);
			var span = [- currentLeft, - currentLeft + this.wrapper.width()];
			var collection = [];

			this.items.each(function() {
				var item = $(this),
					itemLeft = item.position().left;

				if (itemLeft > span[1]) {
					return false; // exceed
				}

				if (itemLeft >= span[0] && itemLeft < span[1]) {
					collection.push(this);
					return true;
				}
			});

			return $(collection);
		},

			reflow: function() {
			if (this.reflowTimeout) {
				clearTimeout(this.reflowTimeout);
			}

			this.reflowTimeout = setTimeout($.proxy(this.reflowImmediately, this), 10);
		},

		reflowImmediately: function() {
			var self = this,
				stageWidth = 0,
				stageHeight = 0,
				targetCol = this.activeItem,//.parents('.cartware-slider-item-wrap'),
				roundingInaccuracy = this.getRoundingInaccuracy();

			this._fitColsInWrap();

			this.cols.each(function() {
				var item = $(this),
					rect = this.getBoundingClientRect ? this.getBoundingClientRect() : null,
					width = rect ?
						(rect.width || rect.right - rect.left) :
						item.outerWidth(false),
					height = rect ?
						(rect.height || rect.bottom - rect.top) :
						item.outerHeight(false);

				width += parseInt(item.css('margin-left'), 10) + parseInt(item.css('margin-right'), 10);
				height += parseInt(item.css('margin-top'), 10) + parseInt(item.css('margin-bottom'), 10);

				stageWidth += width;
				stageHeight = Math.max(stageHeight, height);
			});

			this.stage.css({
				width: stageWidth + roundingInaccuracy,
				height: stageHeight
			});

			/*
			 cols.each(function() {
			 var item = $(this);
			 stageHeight = Math.max(stageHeight, item.outerHeight(true));
			 });

			 stage.css({
			 width: stageWidth
			 });

			 cols.each(function() {
			 var item = $(this);
			 stageHeight = Math.max(stageHeight, item.outerHeight(true));
			 });

			 stage.css({
			 height: stageHeight
			 });
			 */

			this.wrapper.css({
				height: stageHeight +
					parseInt(this.stage.css('padding-top'), 10) +
					parseInt(this.stage.css('padding-bottom'), 10) +
					parseInt(this.stage.css('margin-top'), 10) +
					parseInt(this.stage.css('margin-bottom'), 10)
			});

			if (this.settings.arrows.position === 'middle') {
				$.each([this.controls.previous, this.controls.next], function() {
					var control = $(this);

					control.css({
						top: self.wrapper.innerHeight() / 2 - control.innerHeight() / 2
					});
				});
			}

			if (this.settings.mode === Slider.prototype.MODE_BATCHES) {
				this.cols.each(function() {
					var col = $(this);
					if (col.position().left + roundingInaccuracy >= - (self.stage.css(animateAttributes.left)|0)) {
						targetCol = col;
						return false;
					}
				});

				// var wrapperWidth = this.wrapper.width();
				//
				// this.cols.each(function() {
				// 	var item = $(this);
				//
				// 	if (item.width() + item.position().left <= wrapperWidth + roundingInaccuracy) {
				// 		targetCol = item;
				// 	}
				// });
			}


			var targetStyles = {};
			targetStyles[animateAttributes.left] = - Math.min(targetCol ? targetCol.position().left : 0, this.stage.outerWidth(true) - this.wrapper.outerWidth(true));

			if (this.stage.width() < this.wrapper.width()) {
				targetStyles[animateAttributes.left] = this._getNonFilledLeftValue(this.stage.width());
			}

			if (this.settings.controls) {
				if (this.stage.width() < this.wrapper.width()) {
					if (!this.settings.carousel) {
						$.each(this.controls, function() {
							$(this).css('display', 'none');
						});
					}
				} else {
					$.each(this.controls, function() {
						$(this).css('display', 'block');
					});
				}
			}

			this.stage.css(targetStyles);
			this.checkControls();
			this.renderHandles();

			this.container.trigger('cartware_slider/reflow');
			this.trigger('reflow');
		}
	};

	$.fn.cartwareSlider = function() {
		return this.each(function() {
			var el = $(this),
				options = el.data('config'),
				inst = el.data('cartware_slider/instance');

			if (!inst) {
				el.data('cartware_slider/instance', new Slider(el, options || {}));
			} else if (inst && options) {
				$.extend(inst.options, options);
			}
		});
	};

	function setup() {
		$('.cartware-slider').cartwareSlider();
	}

	setup();
	$(document).ready(setup);
	$(document).ajaxComplete(setup);
});


  }).apply(root, arguments);
});
}(this));

